function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h110.37v110.37H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "M26.992 60.02q0-6.004-2.365-9.405-2.336-3.43-6.447-3.43t-6.475 3.43Q9.37 54.016 9.37 60.02t2.336 9.434q2.365 3.401 6.475 3.401t6.447-3.4q2.365-3.432 2.365-9.435zM9.369 48.457q1.633-2.957 4.11-4.377 2.506-1.45 5.969-1.45 5.743 0 9.318 4.792 3.603 4.79 3.603 12.599 0 7.807-3.603 12.599-3.575 4.79-9.319 4.79-3.462 0-5.968-1.419-2.477-1.449-4.11-4.406v4.968H4.161V30.536h5.208zM54.655 52.1q-3.829 0-6.08 2.75-2.225 2.75-2.225 7.542 0 4.761 2.224 7.541 2.252 2.75 6.081 2.75 3.829 0 6.053-2.75 2.252-2.78 2.252-7.541 0-4.791-2.252-7.542-2.224-2.75-6.053-2.75zm11.289-18.72v5.442q-2.14-1.065-4.335-1.627-2.168-.562-4.308-.562-5.63 0-8.614 3.993-2.956 3.992-3.379 12.066 1.661-2.573 4.167-3.934 2.505-1.39 5.518-1.39 6.334 0 9.994 4.052 3.688 4.022 3.688 10.972 0 6.802-3.83 10.913-3.828 4.11-10.19 4.11-7.291 0-11.148-5.855-3.857-5.885-3.857-17.035 0-10.469 4.73-16.68 4.73-6.24 12.697-6.24 2.14 0 4.307.444 2.196.443 4.56 1.33zM94.231 37.6L79.873 61.171h14.358zm-1.492-5.205h7.15v28.776h5.997v4.968h-5.997v10.41h-5.658V66.14H75.256v-5.767z"
}));

function SvgEmbeddedBase64Artifact(props) {
  return React.createElement("svg", _extends({
    width: 417.146,
    height: 417.146,
    viewBox: "0 0 110.369 110.369"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "embedded-base64-artifact.f9c7b.svg";
export { SvgEmbeddedBase64Artifact as ReactComponent };